import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-mobilefilterpopup',
  templateUrl: './mobilefilterpopup.component.html',
  styleUrls: ['./mobilefilterpopup.component.css']
})
export class MobilefilterpopupComponent implements OnInit {
  dynamicflavourarray: any;
  dynamiclifearray: any;
  tempsearchdata: any;
  dynamicbrandarray: any;
  searchid: any;
  array = [];
  lifestage: any;
  flavour: any;
  brand: any;
  dataarray: any;
  set: any;
  category: any;
  constructor( private dialogRef: MatDialogRef <MobilefilterpopupComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any ) { 
      window.scrollTo(0, 0);
      this.set = this.data.set;
      this.dataarray = this.data.data1;
      this.brand = this.data.brand;
      this.flavour = this.data.flavour;
      this.lifestage = this.data.lifestage;
      console.log(this.set);
      this.category = this.data.category;
      this.searchid = this.data.searchid;
      this.dynamicbrandarray = this.data.dynamicbrandarray;
      this.tempsearchdata =  this.data.tempsearchdata;
      this.dynamiclifearray = this.data.dynamiclifearray;
      this.dynamicflavourarray = this.data.dynamicflavourarray;

     }

  ngOnInit() {
   
  }
  setFilter(i , id) {
    this.array.push({'no': i, 'id': id});
    this.dialogRef.close(this.array);
  }

  brandCount(id) {
    let total = 0;
    for (let i = 0; i < this.dataarray.length ; i++) {
      if (this.dataarray[i].brand_id == id) {
        total = total + 1;
      }
    }
    return total;
  }
  lifestageCount(id) {
    let total = 0;
    for (let i = 0; i < this.dataarray.length ; i++) {
      if (this.dataarray[i].lifestage_id == id) {
        total = total + 1;
      }
    }
    return total;
  }



  tempbrandCount(id) {
 
   let total = 0;
   for (let i = 0; i < this.tempsearchdata.length ; i++) {
     if (this.tempsearchdata[i].brand_id === id) {
       total = total + 1;
     }
   }
   return total;
 }

 templifestageCount(id) {
   
     let total = 0;
     for (let i = 0; i < this.tempsearchdata.length ; i++) {
       if (this.tempsearchdata[i].lifestage_id === id) {
         total = total + 1;
       }
     }
     return total;
   }
   tempflavourCount(id) {
     let total = 0;
     for (let i = 0; i < this.tempsearchdata.length ; i++) {
       if (this.tempsearchdata[i].flavour_id === id) {
         total = total + 1;
       }
     }
     return total;
   }
   flavourCount(id) {
     let total = 0;
     for (let i = 0; i < this.dataarray.length ; i++) {
       if (this.dataarray[i].flavour_id == id) {
         total = total + 1;
       }
     }
     return total;
   }

   close() {
    this.dialogRef.close();
   }
}
